<div class="row">
  <div class="col-sm-12 d-flex justify-content-center mt-3">
    <tan-alert-message
      [errorType]="'error'"
      [message]="
        'Review your Quote, and Approve once done. Quote will only be processed once Approved.'
      "
    >
    </tan-alert-message>
  </div>
</div>

<ng-container>
  <tan-loader
    [loading]="quoteLoading$ | async"
    [loadingText]="'<p>Getting quote</p>'"
  >
  </tan-loader>

  <div
    class="row justify-content-center"
    *ngIf="!(quoteLoading$ | async) && (quoteError$ | async)"
  >
    <div class="col-sm-12 d-flex justify-content-center">
      <tan-alert-message
        [errorType]="'error'"
        [message]="'Could not retrieve Quote'"
      ></tan-alert-message>
    </div>
  </div>

  <ng-container *ngIf="!(quoteLoading$ | async) && !(quoteError$ | async)">
    <div class="row">
      <div class="col-sm-12">
        <div class="container custom-section">
          <div class="row">
            <div class="col-sm-8">
              <span class="section-heading"
                >{{ quote.quoteNumber }} - {{ quote.customer.firstName }}
                {{ quote.customer.lastName }} -
                {{ quote.customer.company.name }}</span
              >
            </div>
            <div
              class="col-sm-4 text-right"
              *ngIf="quote.purchaseLineItems.length > 0"
            >
              <button
                type="button"
                class="btn btn-primary add"
                (click)="updateQuote()"
              >
                <span>Approve</span>
              </button>
            </div>
            <!-- <div class="col-sm-4 text-right" *ngIf="canUpdateStatus">
              <button type="button" class="btn btn-primary add" (click)="updateQuoteStatus()">
                <span>Change status</span>
              </button>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <div class="container custom-section">
          <div class="row" *ngIf="quote.purchaseLineItems.length == 0">
            <div class="col-sm-12">
              <tan-alert-message
                [errorType]="'info'"
                [message]="'No items added to quote'"
              ></tan-alert-message>
            </div>
          </div>

          <ng-container *ngIf="quote.purchaseLineItems.length == 0">
            <div class="row">
              <div class="col-sm-12 d-flex justify-content-center">
                <button
                  type="button"
                  class="btn btn-primary add"
                  (click)="addUnit()"
                >
                  <span>Add Unit</span>
                </button>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="quote.purchaseLineItems.length > 0">
            <div class="row col-heading">
              <div class="col-sm-2">No.</div>
              <div class="col-sm-4">Description</div>
              <div class="col-sm-2 d-flex justify-content-center">QTY</div>
              <div class="col-sm-4 d-flex justify-content-center">Actions</div>
            </div>

            <ng-container *ngFor="let item of quote.purchaseLineItems">
              <div class="row mt-2">
                <div class="col-sm-8">
                  {{ item.unit }}
                </div>
                <div class="col-sm-4 text-right">
                  <button
                    type="button"
                    class="btn btn-primary add"
                    (click)="addUnit()"
                  >
                    <span>Add Unit</span>
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary edit ml-1"
                    (click)="editLineItem(item)"
                  >
                    <span><i class="fa fa-pencil"></i></span>
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary remove ml-1"
                    (click)="openRemoveUnitModal(item)"
                  >
                    <span><i class="fa fa-trash"></i></span>
                  </button>
                  <!-- <ng-container *ngIf="!isCustomer && isStaff">
                    <button type="button" class="btn btn-primary add ml-1" (click)="applyLineItemDiscount(item)">
                      <span>Apply Discount</span>
                    </button>
                  </ng-container> -->
                </div>
              </div>

              <div class="row item-row mt-2">
                <div class="col-sm-2"></div>
                <div class="col-sm-4">
                  <label class="col-form-label"> Template Name </label>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-sm-2"></div>
                <div class="col-sm-4">
                  {{ item.name }}
                </div>
                <div class="col-sm-1 d-flex justify-content-center">
                  {{ item.quantity }}
                </div>
              </div>

              <div class="row item-row mt-2">
                <div class="col-sm-2"></div>
                <div class="col-sm-4">
                  <label class="col-form-label"> Travel charge(s) </label>
                </div>
              </div>
              <div class="row item-row mt-2" *ngIf="item.deliveryCharge">
                <div class="col-sm-2"></div>
                <div class="col-sm-4">
                  {{ item.deliveryCharge.transportCharge.name }} -
                  {{ item.deliveryCharge.transportLocation.district.name }} -
                  {{ item.deliveryCharge.transportLocation.name }}
                </div>
                <div class="col-sm-1 d-flex justify-content-center">
                  {{ item.quantity }}
                </div>
                <div class="col-sm-3"></div>
              </div>
              <!-- optional / joining charge -->
              <div
                class="row item-row mt-2"
                *ngIf="item.deliveryChargeOptional"
              >
                <div class="col-sm-2"></div>
                <div class="col-sm-4">
                  {{ item.deliveryChargeOptional.transportCharge.name }} -
                  {{
                    item.deliveryChargeOptional.transportLocation.district.name
                  }}
                  -
                  {{ item.deliveryChargeOptional.transportLocation.name }}
                </div>
                <div class="col-sm-1 d-flex justify-content-center">
                  {{ item.quantity }}
                </div>
                <div class="col-sm-3"></div>
              </div>

              <!-- <div class="row item-row mt-2">
                <div class="col-sm-2"></div>
                <div class="col-sm-4">
                  <label class="col-form-label">
                    Products
                  </label>
                </div>
              </div>
              <div class="row item-row mt-2" *ngFor="let item of quote.purchaseLineItems">
                <div class="col-sm-2"></div>
                <div class="col-sm-4">
                  <div *ngFor="let product of item.purchaseAssetItemConfigurations">
                    {{ product.name}}
                  </div>
                </div>
                <div class="col-sm-1">
                  <div class="d-flex justify-content-center" *ngFor="let product of item.purchaseAssetItemConfigurations">
                    {{ product.quantity }}
                  </div>
                </div>
              </div> -->
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<tan-modal
  #editQuoteStatusModal
  [size]="'md'"
  [title]="'Edit Status'"
  [showInformationBlock]="false"
  (onSave)="saveUpdateQuote()"
>
  <div modal-content>
    <div class="container">
      <tan-loader
        [loading]="updateQuoteLoading$ | async"
        [loadingText]="'<p>Updating Quote Status</p>'"
      >
      </tan-loader>

      <div class="row justify-content-center" *ngIf="updateQuoteError$ | async">
        <div class="col-sm-12 d-flex justify-content-center">
          <tan-alert-message
            [errorType]="'error'"
            [message]="'Could not update Quote Status'"
          ></tan-alert-message>
        </div>
      </div>

      <div
        class="row"
        *ngIf="!(updateQuoteError$ | async) && !(updateQuoteLoading$ | async)"
      >
        <div class="col-sm-12">
          <div class="">
            <form class="mt-3" [formGroup]="editQuoteForm">
              <div class="form-group">
                <label class="control-label" for="quote_status">Status</label>
                <select
                  class="form-control"
                  formControlName="quote_status"
                  id="quote_status"
                  (change)="setQuoteStatus()"
                >
                  <option [ngValue]="null">Please select</option>
                  <option
                    *ngFor="let status of quoteStatus"
                    [ngValue]="status.id"
                  >
                    {{ status.name }}
                  </option>
                </select>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</tan-modal>

<tan-modal
  #removeUnitModal
  [size]="'lg'"
  [title]="'Please confirm'"
  [showInformationBlock]="false"
  (onSave)="removeUnit()"
>
  <div modal-content>
    <div class="container">
      <ng-container *ngTemplateOutlet="confirmRemoveUnitContent"></ng-container>
    </div>
  </div>
</tan-modal>

<ng-template #confirmRemoveUnitContent>
  <ng-container
    *ngIf="selectedModalLineItem != null && selectedModalLineItemExtra == null"
  >
    <p>Are you sure you want to remove this?</p>
    <!-- <div class="mt-3">
      <label>Daily rate:</label><br>
      <span>{{selectedModalLineItem.rentalOption.dailyRate}}</span>
    </div>
    <div class="mt-3">
      <label>Monthly rate:</label><br>
      <span>{{selectedModalLineItem.rentalOption.monthlyRate}}</span>
    </div>
    <div class="mt-3">
      <label>Period requested:</label><br>
      <span>{{selectedModalLineItem.rentalOption.period.period}}</span>
    </div> -->
  </ng-container>
</ng-template>

<tan-modal
  #addUnitModal
  [size]="'xl'"
  [title]="modalTitle"
  [showInformationBlock]="false"
  [showActionButton]="true"
  [actionButtonLabel]="savingUnit ? ' Saving' : 'Save'"
  (closeModal)="resetPurchaseForm()"
  [hasSecondarySave]="true"
  [actionButtonSecondaryLabel]="'Cancel'"
  (onSecondarySave)="closeAddUnit()"
  (onSave)="saveUnit()"
  [isDisabled]="transportOneLoading"
>
  <div modal-content>
    <div class="container">
      <ng-container *ngTemplateOutlet="unitConfig"></ng-container>
    </div>
  </div>
</tan-modal>

<ng-template #unitConfig let-item>
  <tan-loader
    [loading]="preloadingEditForm"
    [loadingText]="'<p>Fetching Unit Details</p>'"
  >
  </tan-loader>

  <form *ngIf="!preloadingEditForm" class="mt-2" [formGroup]="purchaseForm">
    <div class="row mt-2">
      <div class="col-md-6 col-sm-12">
        <tan-loader
          [loading]="fpProjectCategoryLoading$ | async"
          [loadingText]="'<p>Loading Building types</p>'"
        >
        </tan-loader>

        <div
          class="row justify-content-center"
          *ngIf="fpProjectCategoryError$ | async"
        >
          <div class="col-sm-12 d-flex justify-content-center">
            <tan-alert-message
              [errorType]="'error'"
              [message]="'Could not retrieve Building types'"
            >
            </tan-alert-message>
          </div>
        </div>

        <div
          class="form-group"
          *ngIf="
            !(fpProjectCategoryLoading$ | async) &&
            !(fpProjectCategoryError$ | async)
          "
        >
          <label class="control-label" for="project_category"
            >Building type</label
          >
          <select
            class="form-control"
            formControlName="project_category"
            id="project_category"
            (change)="setFpProjectCategory()"
          >
            <option [ngValue]="null">Please select</option>
            <option *ngFor="let cat of fpProjectCategories" [ngValue]="cat">
              {{ cat.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-sm-12 col-md-6" *ngIf="selectedFpProjectCategory">
        <tan-loader
          [loading]="fpProjectSubCategoryLoading$ | async"
          [loadingText]="'<p>Loading Categories</p>'"
        >
        </tan-loader>

        <div
          class="row justify-content-center"
          *ngIf="fpProjectSubCategoryError$ | async"
        >
          <div class="col-sm-12 d-flex justify-content-center">
            <tan-alert-message
              [errorType]="'error'"
              [message]="'Could not retrieve Categories'"
            >
            </tan-alert-message>
          </div>
        </div>

        <div
          class="form-group"
          *ngIf="
            !(fpProjectSubCategoryLoading$ | async) &&
            !(fpProjectSubCategoryError$ | async)
          "
        >
          <label class="control-label" for="project_sub_category"
            >Category</label
          >
          <select
            class="form-control"
            formControlName="project_sub_category"
            id="project_sub_category"
            (change)="setFpProjectSubCategory()"
          >
            <option [ngValue]="null">Please select</option>
            <option *ngFor="let cat of fpProjectSubCategories" [ngValue]="cat">
              {{ cat.name }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="row mt-2" *ngIf="selectedFpProjectSubCategory">
      <div class="col-sm-12 col-md-6" *ngIf="selectedFpProjectSubCategory">
        <tan-loader
          [loading]="fpProjectSizeLoading$ | async"
          [loadingText]="'<p>Loading Available sizes</p>'"
        >
        </tan-loader>

        <div
          class="row justify-content-center"
          *ngIf="fpProjectSizeError$ | async"
        >
          <div class="col-sm-12 d-flex justify-content-center">
            <tan-alert-message
              [errorType]="'error'"
              [message]="'Could not retrieve matching sizes'"
            >
            </tan-alert-message>
          </div>
        </div>

        <div
          class="form-group"
          *ngIf="
            !(fpProjectSizeLoading$ | async) && !(fpProjectSizeError$ | async)
          "
        >
          <label class="control-label" for="project_size">Size</label>
          <select
            class="form-control"
            formControlName="project_size"
            id="project_size"
            (change)="setFpProjectSize()"
          >
            <option [ngValue]="null">Please select</option>

            <option *ngFor="let size of fpProjectSizes" [ngValue]="size">
              {{ size.size }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-sm-12 col-md-6" *ngIf="selectedFpProjectSize">
        <tan-loader
          [loading]="fpProjectExtrasLoading$ | async"
          [loadingText]="'<p>Loading Variations</p>'"
        >
        </tan-loader>

        <div
          class="row justify-content-center"
          *ngIf="fpProjectExtrasError$ | async"
        >
          <div class="col-sm-12 d-flex justify-content-center">
            <tan-alert-message
              [errorType]="'error'"
              [message]="'Could not retrieve variations'"
            >
            </tan-alert-message>
          </div>
        </div>

        <div
          class="form-group"
          *ngIf="
            !(fpProjectExtrasLoading$ | async) &&
            !(fpProjectExtrasError$ | async)
          "
        >
          <label class="control-label" for="project_extra"
            >Variation option</label
          >
          <select
            class="form-control"
            formControlName="project_extra"
            id="project_extra"
            (change)="setFpProjectExtra()"
          >
            <option [ngValue]="null">Please select</option>
            <option *ngFor="let extra of fpProjectExtras" [ngValue]="extra">
              {{ extra.name }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="row mt-2" *ngIf="showQty">
      <div class="col-sm-12 col-md-6">
        <div class="form-group">
          <label class="control-label" for="quantity">* Quantity</label>
          <input
            type="number"
            class="form-control"
            formControlName="quantity"
            [value]="unitQty"
            (ngModelChange)="setUnitQty()"
            min="0"
            oninput="validity.valid||(value='')"
          />
          <span
            class="error"
            *ngIf="
              purchaseForm.get('quantity').touched &&
              purchaseForm.get('quantity').errors?.required
            "
          >
            Quantity is required</span
          >
        </div>
      </div>
    </div>

    <ng-container *ngIf="qtyEntered">
      <tan-loader
        [loading]="fpProjectListLoading$ | async"
        [loadingText]="'<p>Fetching projects</p>'"
      >
      </tan-loader>

      <div
        class="row justify-content-center"
        *ngIf="!(fpProjectListLoading$ | async) && (projectListError$ | async)"
      >
        <div class="col-sm-12 d-flex justify-content-center">
          <tan-alert-message
            [errorType]="'error'"
            [message]="'Could not retrieve variations'"
          >
          </tan-alert-message>
        </div>
      </div>

      <div
        class="container custom-section"
        *ngIf="
          projects.length === 0 &&
          selectedFpProjectSize &&
          selectedFpProjectSubCategory &&
          selectedFpProjectCategory &&
          selectedFpProjectExtra &&
          !(fpProjectListLoading$ | async)
        "
      >
        <div class="row justify-content-center">
          <div class="col-sm-12 d-flex justify-content-center mt-3">
            <tan-alert-message
              [errorType]="'info'"
              [message]="'Could not find a project that matches your criteria.'"
            >
            </tan-alert-message>
          </div>
        </div>
      </div>

      <div
        class="form-group"
        *ngIf="
          !(projectListLoading$ | async) &&
          !(projectListError$ | async) &&
          projects.length > 0 &&
          qtyEntered
        "
      >
        <label class="control-label" for="template_option"
          >Template Option</label
        >
        <select
          class="form-control"
          formControlName="template_option"
          id="template_option"
          (change)="setTemplateOption()"
        >
          <option [ngValue]="null">Please select</option>
          <option
            *ngFor="let proj of projects"
            [ngValue]="proj.floorplannerProjectId"
          >
            {{ proj.name }}
          </option>
        </select>
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        !(fpProjectListLoading$ | async) &&
        !(fpProjectListError$ | async) &&
        projects.length > 0 &&
        showTemplateOption
      "
    >
      <div class="row">
        <label class="col-sm-12 col-form-label">
          You have selected the below option:
        </label>
      </div>
      <div class="row mb-2">
        <div class="col-sm-9">
          {{ selectedTemplateOption.name }}
        </div>
        <div class="col-sm-3 ar">
          <div class="d-inline-block">
            <button
              class="btn btn-secondary table-filter-btn"
              id="viewItem"
              (click)="viewItem()"
            >
              <span class="fa fa-eye text-white"></span> View
            </button>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="showTemplateOption && quote.shipping">
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label class="control-label" for="transport_load_one"
              >* Transport Option</label
            >
            <select
              class="form-control"
              formControlName="transport_load_one"
              id="transport_load_one"
              (change)="setSelectedTransportLoadOne()"
            >
              <option [ngValue]="null">Please select</option>
              <option *ngFor="let size of transportLoads" [ngValue]="size.id">
                {{ size.size }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="control-label" for="transport_load_one_qty"
              >* Qty of Trucks required</label
            >
            <input
              type="number"
              class="form-control"
              formControlName="transport_load_one_qty"
              [value]="loadOneQty"
              (change)="setSelectedTransportLoadOne()"
              (keyup)="setSelectedTransportLoadOne()"
            />
            <span
              class="error"
              *ngIf="
                purchaseForm.get('transport_load_one_qty').touched &&
                purchaseForm.get('transport_load_one_qty').errors?.required
              "
            >
              Qty is required</span
            ><br />
          </div>
        </div>
        <tan-loader
          [loading]="transportOneLoading"
          [loadingText]="'<p>Calculating charges..</p>'"
        >
        </tan-loader>
      </div>
    </ng-container>

    <ng-container
      *ngIf="showTemplateOption && quote.shipping && addSecondTransportLoad"
    >
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label class="control-label" for="transport_load_two"
              >* Transport Option</label
            >
            <select
              class="form-control"
              formControlName="transport_load_two"
              id="transport_load_two"
              (change)="setSelectedTransportLoadTwo()"
            >
              <option [ngValue]="null">Please select</option>
              <option *ngFor="let size of transportLoads" [ngValue]="size.id">
                {{ size.size }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="control-label" for="transport_load_two_qty"
              >* Qty of Trucks required</label
            >
            <input
              type="number"
              class="form-control"
              formControlName="transport_load_two_qty"
              [value]="loadTwoQty"
              (change)="setSelectedTransportLoadTwo()"
            />
            <span
              class="error"
              *ngIf="
                purchaseForm.get('transport_load_two_qty').touched &&
                purchaseForm.get('transport_load_two_qty').errors?.required
              "
            >
              Qty is required</span
            ><br />
          </div>
        </div>
        <tan-loader
          [loading]="transportTwoLoading"
          [loadingText]="'<p>Calculating charges..</p>'"
        >
        </tan-loader>
      </div>
    </ng-container>

    <div class="row" *ngIf="showTemplateOption && quote.shipping">
      <div class="col-sm-12 ">
          <span class="guidance-text"><strong>Note:</strong></span><br>
          <span class="guidance-text">1. A single 3m/6m building could be transported on a 6m truck</span><br>
          <span class="guidance-text">2. A single 9m/12m building could be transported on a 12m truck</span><br>
          <span class="guidance-text">3. Two 6m buildings can be transported on a 12m truck</span><br>
          <span class="guidance-text">4. Two 3m building can be transported on a 6m truck</span><br>
          <span class="guidance-text">5. Classroom transport price calculated automatically</span><br>
          <span class="guidance-text">6. The transport price has been provided as an estimate, please contact a Kwikspace representative for discounted rates, where units can be placed on combined load/truck sizes.</span>
        </div>
  </div>

    <div
      class="row justify-content-center mt-3 mb-3"
      *ngIf="showTemplateOption && quote.shipping && !addSecondTransportLoad"
    >
      <div class="col-sm-12 d-flex justify-content-center">
        <button
          type="button"
          class="btn btn-primary truck-btn"
          (click)="addAnotherTruck()"
        >
          <span>Add another truck</span>
        </button>
      </div>
    </div>
  </form>

  <tan-modal
    #viewProjectImgModal
    [size]="'xl'"
    [title]="'Project Visualisation'"
    [showInformationBlock]="false"
    [showActionButton]="false"
  >
    <div modal-content>
      <div class="container" *ngIf="projectToView">
        <div class="row mt-3">
          <div class="col-sm-12">
            <ng-container *ngIf="projectToView.thumbnail3d != null">
              <div class="row">
                <div class="col-sm-12">
                  <h4 class="mb-3">3D Image</h4>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 d-flex justify-content-center">
                  <img [src]="projectToView.thumbnail3d" />
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </tan-modal>
</ng-template>
